import L from "leaflet";

export const AccidentIcon = L.icon({
	iconUrl: require("../../../shared/assets/images/red_pin.png"),
	iconSize: [30, 30],
});
